import { Injectable } from '@angular/core';
import {
  Company,
  CurrentCompanyLoaded,
  LoadCurrentCompany,
  LoadCurrentPublicCompany,
} from '@macs-frontend/web-macs/shared';
import { Store } from '@ngrx/store';
import { runInAction } from 'mobx';
import { State } from '../../reducers';
import * as fromMeta from '../../reducers/meta';
import { NavigationStore } from '../store/navigation.store';
import { BehaviorSubject } from 'rxjs';
import { behaviorSubjectFromSelector, rx } from '@macs-frontend/core/utils/rx';
import { FetchPolicy } from '@apollo/client/core/watchQueryOptions';
import { emptyCompany } from '@macs-frontend/features/shared/models/company.model';
import { CurrentCompanyForClientGQL } from '@macs-gql';
import { CurrentUserService } from '@macs-frontend/core/services/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentCompanyService {
  currentCompany$ = behaviorSubjectFromSelector(this.store$, fromMeta.getCurrentCompany);
  currentCompanyPublic$ = this.store$.select(fromMeta.getCurrentCompanyPublic);
  currency$ = this.store$.select(fromMeta.getCurrency);
  dateFormat$ = this.store$.select(fromMeta.getDateFormat);
  dateFormatForNgZorro$ = this.store$.select(fromMeta.getDateFormatForNgZorro);
  primeNgCalendarDateFormat$ = this.store$.select(fromMeta.getPrimeNgCalendarDateFormat);

  constructor(
    private readonly store$: Store<State>,
    private readonly navigationStore: NavigationStore,
    private readonly clientCompanyGQL: CurrentCompanyForClientGQL,
    private readonly currentUserService: CurrentUserService,
  ) {
    this.loadCurrentCompany();
  }

  loadCurrentCompany() {
    if (runInAction(() => this.navigationStore.history[0].url.startsWith('/public'))) {
      this.loadPublicCompany();
    } else {
      this.currentUserService.user$
        .pipe(
          rx.filter(user => !!user && !!user.uuid),
          rx.take(1),
        )
        .subscribe(user => {
          if (user.companyUser) {
            this.store$.dispatch(new LoadCurrentCompany());
          } else {
            this.loadCompanyForClient();
          }
        });
    }
  }

  loadCompanyForClient() {
    this.clientCompanyGQL
      .fetch(undefined, {
        fetchPolicy: 'network-only',
      })
      .subscribe(resp => {
        const company = { ...emptyCompany };
        Object.entries(resp.data.current_company).forEach(([key, value]) => {
          if (key in company && value) {
            // @ts-ignore
            company[key] = value;
          }
        });
        this.store$.dispatch(new CurrentCompanyLoaded(company));
      });
  }

  loadPublicCompany() {
    this.store$.dispatch(new LoadCurrentPublicCompany());
  }
}
